import { ClickAwayListener, IconButton } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { MoreActionsIcon } from 'src/components/icons';
import { BaseActionsMenuProps } from 'src/constants';
import * as Colors from 'src/theme/colors';

import { Action } from '.';

const useStyles = makeStyles()(() => ({
  menuItemActive: {
    backgroundColor: Colors.HoverNonBorderBackground,
  },
}));

interface BaseActionsMenuButtonProps {
  actions?: Action[];
  onActionMenuClick: (event: BaseActionsMenuProps) => void;
  parentComponentType?: 'toolbar' | 'tableAction';
}

export const BaseActionsMenuButton: React.FC<BaseActionsMenuButtonProps> = ({
  actions,
  onActionMenuClick,
  parentComponentType = 'tableAction',
}) => {
  const [isActive, setActiveStatus] = React.useState(false);

  const { classes } = useStyles();
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setActiveStatus(true);
    onActionMenuClick({
      actions: actions && actions.length > 0 ? actions : [],
      menuProps: {
        anchorEl: event.currentTarget,
        keepMounted: true,
        open: true,
        anchorOrigin: {
          vertical: 32,
          horizontal: 'right',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      },
    });
  };

  const removeActiveState = () => {
    setActiveStatus(false);
  };

  return actions?.length || parentComponentType === 'toolbar' ? (
    <ClickAwayListener onClickAway={removeActiveState} disableReactTree>
      <IconButton
        aria-label="more actions"
        aria-controls="more-actions-menu"
        aria-haspopup="true"
        data-testid="more-actions-menu"
        onClickCapture={handleClick}
        onMouseLeave={removeActiveState}
        color="secondary"
        size="small"
        className={isActive ? classes.menuItemActive : ''}
      >
        <MoreActionsIcon
          htmlColor={Colors.GraySmall}
          style={{ fontSize: 20 }}
        />
      </IconButton>
    </ClickAwayListener>
  ) : (
    <div />
  );
};
